// extracted by mini-css-extract-plugin
export default {"myProgress":"ProgressBar_myProgress__7tAZt","myBar":"ProgressBar_myBar__Qd36w","logoImage":"ProgressBar_logoImage__ak28H"};